<app-assessment-call
  [controlService]="controlService"
  [realtimeService]="realtimeService"
  [userVideoService]="userVideoService"
  [deviceSettingsService]="deviceSettingsService"
  [playerService]="playerService"
  [callStore]="callStore"
  [enrollmentUuid]="enrollmentUuid"
  [title]="title()"
  [captionText]="captionText()"
  [subtitleKind]="subtitle().kind"
  [subtitleText]="subtitle().text"
  [subtitleFormatting]="subtitle().formatting"
  [avatarPhotoUrl]="avatarPhotoUrl()"
  [showAvatarPhoto]="showAvatarPhoto()"
  [mainIsLoading]="mainIsLoading()"
  [disableConfirmActionButton]="disableConfirmActionButton()"
  (settingsClicked)="handleSettingsClick()"
  (completeStep)="handleCompleteStep()"
  (leaveStep)="handleLeaveStep()"
></app-assessment-call>

<app-device-settings-modal
  *ngIf="deviceSettingsService.displayModal"
  [deviceSettingsService]="deviceSettingsService"
  [controlService]="controlService"
></app-device-settings-modal>
